module.exports = __webpack_public_path__ + "static/media/id.002f64df.svg";